var _stop, _stop2, _stop3, _stop4, _stop5, _stop6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgTextSelected(props) {
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.76.857v22.286",
    stroke: "url(#".concat(_id, ")"),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.474 23.143h8.572",
    stroke: "url(#".concat(_id2, ")"),
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.332 5.143V2.57A1.714 1.714 0 015.046.857h15.428a1.714 1.714 0 011.715 1.714v2.572",
    stroke: "url(#".concat(_id3, ")"),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 13.755,
    y1: 22.934,
    x2: 13.755,
    y2: 0.857,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 17.006,
    y1: 24.134,
    x2: 17.006,
    y2: 23.143,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 22.1,
    y1: 5.103,
    x2: 22.1,
    y2: 0.857,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  })))));
}
export default SvgTextSelected;